import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateOrderSession200,
  CreateOrderSession401,
  CreateOrderSession500,
  CreateOrderSessionBody,
  GetOrderInfo200,
  GetOrderInfo401,
  GetOrderInfo404,
  GetOrderInfo500,
  IssueReceipt200,
  IssueReceiptBody,
  RequestRefund200,
  RequestRefundBody,
  VerifyAmount200,
  VerifyAmountBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary 환불 요청
 */
export const requestRefund = (
    requestRefundBody: RequestRefundBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RequestRefund200>(
      {url: `/api/v1/payment/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestRefundBody
    },
      options);
    }
  


export const getRequestRefundMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestRefund>>, TError,{data: RequestRefundBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestRefund>>, TError,{data: RequestRefundBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestRefund>>, {data: RequestRefundBody}> = (props) => {
          const {data} = props ?? {};

          return  requestRefund(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequestRefundMutationResult = NonNullable<Awaited<ReturnType<typeof requestRefund>>>
    export type RequestRefundMutationBody = RequestRefundBody
    export type RequestRefundMutationError = unknown

    /**
 * @summary 환불 요청
 */
export const useRequestRefund = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestRefund>>, TError,{data: RequestRefundBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof requestRefund>>,
        TError,
        {data: RequestRefundBody},
        TContext
      > => {

      const mutationOptions = getRequestRefundMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 영수증 발급
 */
export const issueReceipt = (
    issueReceiptBody: IssueReceiptBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<IssueReceipt200>(
      {url: `/api/v1/payment/receipt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: issueReceiptBody
    },
      options);
    }
  


export const getIssueReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueReceipt>>, TError,{data: IssueReceiptBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof issueReceipt>>, TError,{data: IssueReceiptBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof issueReceipt>>, {data: IssueReceiptBody}> = (props) => {
          const {data} = props ?? {};

          return  issueReceipt(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IssueReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof issueReceipt>>>
    export type IssueReceiptMutationBody = IssueReceiptBody
    export type IssueReceiptMutationError = unknown

    /**
 * @summary 영수증 발급
 */
export const useIssueReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof issueReceipt>>, TError,{data: IssueReceiptBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof issueReceipt>>,
        TError,
        {data: IssueReceiptBody},
        TContext
      > => {

      const mutationOptions = getIssueReceiptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 결제 금액 검증
 */
export const verifyAmount = (
    verifyAmountBody: VerifyAmountBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<VerifyAmount200>(
      {url: `/api/v1/payment/verify-amount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyAmountBody
    },
      options);
    }
  


export const getVerifyAmountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAmount>>, TError,{data: VerifyAmountBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyAmount>>, TError,{data: VerifyAmountBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyAmount>>, {data: VerifyAmountBody}> = (props) => {
          const {data} = props ?? {};

          return  verifyAmount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyAmountMutationResult = NonNullable<Awaited<ReturnType<typeof verifyAmount>>>
    export type VerifyAmountMutationBody = VerifyAmountBody
    export type VerifyAmountMutationError = unknown

    /**
 * @summary 결제 금액 검증
 */
export const useVerifyAmount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAmount>>, TError,{data: VerifyAmountBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof verifyAmount>>,
        TError,
        {data: VerifyAmountBody},
        TContext
      > => {

      const mutationOptions = getVerifyAmountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 단건 결제용 주문 세션 생성
 */
export const createOrderSession = (
    createOrderSessionBody: CreateOrderSessionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateOrderSession200>(
      {url: `/api/v1/payment/create-order-session`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrderSessionBody
    },
      options);
    }
  


export const getCreateOrderSessionMutationOptions = <TError = CreateOrderSession401 | CreateOrderSession500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderSession>>, TError,{data: CreateOrderSessionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrderSession>>, TError,{data: CreateOrderSessionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrderSession>>, {data: CreateOrderSessionBody}> = (props) => {
          const {data} = props ?? {};

          return  createOrderSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createOrderSession>>>
    export type CreateOrderSessionMutationBody = CreateOrderSessionBody
    export type CreateOrderSessionMutationError = CreateOrderSession401 | CreateOrderSession500

    /**
 * @summary 단건 결제용 주문 세션 생성
 */
export const useCreateOrderSession = <TError = CreateOrderSession401 | CreateOrderSession500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrderSession>>, TError,{data: CreateOrderSessionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createOrderSession>>,
        TError,
        {data: CreateOrderSessionBody},
        TContext
      > => {

      const mutationOptions = getCreateOrderSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 주문 정보 조회
 */
export const getOrderInfo = (
    orderId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrderInfo200>(
      {url: `/api/v1/payment/orders/${orderId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrderInfoQueryKey = (orderId: string,) => {
    return [`/api/v1/payment/orders/${orderId}`] as const;
    }

    
export const getGetOrderInfoInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOrderInfo>>, TError = GetOrderInfo401 | GetOrderInfo404 | GetOrderInfo500>(orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderInfo>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderInfoQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderInfo>>> = ({ signal }) => getOrderInfo(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderInfoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderInfo>>>
export type GetOrderInfoInfiniteQueryError = GetOrderInfo401 | GetOrderInfo404 | GetOrderInfo500

/**
 * @summary 주문 정보 조회
 */
export const useGetOrderInfoInfinite = <TData = Awaited<ReturnType<typeof getOrderInfo>>, TError = GetOrderInfo401 | GetOrderInfo404 | GetOrderInfo500>(
 orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderInfo>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrderInfoInfiniteQueryOptions(orderId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOrderInfoQueryOptions = <TData = Awaited<ReturnType<typeof getOrderInfo>>, TError = GetOrderInfo401 | GetOrderInfo404 | GetOrderInfo500>(orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderInfo>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderInfoQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderInfo>>> = ({ signal }) => getOrderInfo(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderInfo>>>
export type GetOrderInfoQueryError = GetOrderInfo401 | GetOrderInfo404 | GetOrderInfo500

/**
 * @summary 주문 정보 조회
 */
export const useGetOrderInfo = <TData = Awaited<ReturnType<typeof getOrderInfo>>, TError = GetOrderInfo401 | GetOrderInfo404 | GetOrderInfo500>(
 orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderInfo>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrderInfoQueryOptions(orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



